import { AxiosRequestConfig } from "axios";

export const postSubscriptionConfig = (authorization: string | undefined): AxiosRequestConfig => ({
  method: "post",
  url: `/me/subscription`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    Authorization: authorization && `Bearer ${authorization}`,
  },
});
